/** Melanie's readiness-report consult scheduler. */
export const CONSULT_MEETING_URL =
  'https://meetings.hubspot.com/melanie-hahn/readiness-report-consult'

interface ConsultPrefill {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
}

/**
 * Builds the scheduler link with HubSpot's prefill params, dropping any value the
 * practitioner has not given us.
 *
 * Hand-encoded rather than built with `URLSearchParams`, which serializes a space as
 * `+` — HubSpot prefills that literally, so a two-word name arrives as `Mary+Jane`.
 */
export const buildConsultUrl = (user: ConsultPrefill | null): string => {
  const fields: [string, string | null | undefined][] = [
    ['firstname', user?.firstName],
    ['lastname', user?.lastName],
    ['email', user?.email],
  ]

  const query = fields
    .filter(([, value]) => Boolean(value))
    .map(([key, value]) => `${key}=${encodeURIComponent(value ?? '')}`)
    .join('&')

  return query ? `${CONSULT_MEETING_URL}?${query}` : CONSULT_MEETING_URL
}
